import { useMemo } from "react";
import { array, arrayOf, number, object, shape, string } from "prop-types";
import { Grid } from "@material-ui/core";

export const ErrorList = ({
  errors: ungroupedErrors
}) => {

  const errors = useMemo(() => {
    const groups = [];
    ungroupedErrors.forEach(e => {
      const messages = e?.error?.errors ? Object.values(e.error.errors) : [];
      
      for (const message of messages) {
        const existingGroup = groups.find(g => g.name === message);
        if(existingGroup)
          existingGroup.elements.push(e.name);
        else
          groups.push({ name: message, elements: [e.name] });
      }
    });
    
    return groups;
  }, []);
  
  return <Grid item container>
    {
      errors.map(({ name, elements }) => (
        <Grid item container direction="column" key={name}>
          <p><strong>{name}</strong>{" in:"}</p>
          <ul className="pl-8 mt-1 mb-4">
            {
              elements.map((e) => <li key={e}>{e}</li>)
            }
          </ul>
        </Grid>
      ))
    }
  </Grid>
}

ErrorList.propTypes = {
  errors: arrayOf(shape({
    id: number.isRequired,
    name: string.isRequired,
    error: shape({
      errorMessages: array.isRequired,
      errors: object.isRequired,
    }).isRequired
  })),
}